import { NgModule } from '@angular/core';
import { WorkplaceAppModule } from '@app/app.module';
import { AppComponent } from '@app/app.component';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { BaseTrackingService } from '@app/tracking/base-tracking.service';
import { AppInsightsService } from '@app/tracking/app-insights.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxHotjarModule } from 'ngx-hotjar';
import { FullAppRoutingModule } from '@app/app-routing-full.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MsTeamsModule } from '@app/modules/msteams/msteams.module';

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    WorkplaceAppModule.forRoot(),
    FullAppRoutingModule,
    NgxHotjarModule.forRoot(environment.featureSettings.hotJarKey),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    MsTeamsModule
  ],
  providers: [
    { provide: CUSTOMERENVIRONMENT, useValue: environment },
    { provide: BaseTrackingService, useClass: AppInsightsService}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
